import { Controller } from "@hotwired/stimulus";

const TOAST_LIFETIME_MS = 3000;

export default class extends Controller {
  static targets = ["panels", "toast"];

  // Notices and successes go by themselves; alerts and errors stay until clicked away.
  // A stream that replaces the panels connects a fresh toast with its own timer.
  toastTargetConnected(toast) {
    setTimeout(() => toast.remove(), TOAST_LIFETIME_MS);
  }

  // Clear the panels, not `this.element` — removing #notification would delete the
  // element every turbo_stream response updates. See history/43.
  dismiss() {
    this.panelsTarget.replaceChildren();
  }
}
